import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

export default function StandalonePreview() {
  const { clientId } = useParams();
  const [clientName, setClientName] = useState('');

  useEffect(() => {
    // Fetch client name
    const fetchClientName = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API}/clients/${clientId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setClientName(response.data.name || 'Business');
      } catch (error) {
        console.error('Failed to fetch client name:', error);
        setClientName('Business Preview');
      }
    };

    if (clientId) {
      fetchClientName();
    }
  }, [clientId]);

  return (
    <div style={{ 
      width: '100vw', 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      margin: 0,
      padding: 0,
      backgroundColor: '#f9fafb'
    }}>
      {/* Header with business name */}
      <div style={{
        padding: '20px 40px',
        backgroundColor: 'white',
        borderBottom: '1px solid #e5e7eb',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#111827',
          margin: 0
        }}>
          {clientName}
        </h1>
      </div>

      {/* Main content area with chatbot */}
      <div style={{
        flex: 1,
        position: 'relative',
        padding: '40px',
        overflow: 'hidden'
      }}>
        {/* Placeholder content */}
        <div style={{
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <h2 style={{ 
            fontSize: '28px', 
            fontWeight: '600', 
            color: '#374151',
            marginBottom: '16px'
          }}>
            Welcome to {clientName}
          </h2>
          <p style={{
            fontSize: '16px',
            color: '#6b7280',
            lineHeight: '1.6',
            marginBottom: '24px'
          }}>
            This is a standalone preview of your chatbot. The widget appears in the bottom-right corner, 
            just as it would on your actual website. Try clicking on it to test the full functionality!
          </p>
          <div style={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            marginBottom: '24px'
          }}>
            <h3 style={{ 
              fontSize: '18px', 
              fontWeight: '600', 
              color: '#111827',
              marginBottom: '12px'
            }}>
              About Our Service
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#6b7280',
              lineHeight: '1.6'
            }}>
              We're here to help! Our AI-powered chatbot can answer your questions instantly, 
              24/7. Click the chat icon in the bottom-right corner to get started.
            </p>
          </div>
        </div>

        {/* Chatbot Widget Iframe */}
        <iframe
          src={`/widget/${clientId}`}
          style={{
            position: 'fixed',
            bottom: 0,
            right: 0,
            width: '100%',
            height: '100%',
            border: 'none',
            pointerEvents: 'auto',
            zIndex: 9999
          }}
          title="Chat Widget"
        />
      </div>
    </div>
  );
}
